module.exports = __webpack_public_path__ + "static/img/FI@3x.8f8e1599.jpg";